// @ts-check
// Modelos em análise na Meta: a tela se atualiza sozinha a cada 20 s com a aba visível, por até 10 minutos depois da
// última ação (mesma regra de Configurações > Modelos do WhatsApp, contrato 08 de leads e WhatsApp, seção 7). Usado
// pela aba WhatsApp de Campanhas > Modelos e pela página do modelo (contrato 09 de campanhas de WhatsApp, seção 18).
import { useEffect, useRef } from 'preact/hooks';

export const REVIEW_REFRESH_MILLISECONDS = 20_000;
export const REVIEW_REFRESH_LIMIT_MILLISECONDS = 10 * 60_000;

/** @param {{ status?: string } | null | undefined} template */
export const isTemplateInReview = (template) => template?.status === 'PENDING' || template?.status === 'IN_APPEAL';

/**
 * @param {boolean} isActive há modelo em análise na tela
 * @param {() => unknown} reload
 * @returns {{ restart: () => void }} restart: conta os 10 minutos de novo (depois de criar ou sincronizar)
 */
export function useReviewRefresh(isActive, reload) {
  const startedAtRef = useRef(Date.now());
  const reloadRef = useRef(reload);
  reloadRef.current = reload;
  useEffect(() => {
    if (!isActive) return undefined;
    const interval = setInterval(() => {
      if (Date.now() - startedAtRef.current > REVIEW_REFRESH_LIMIT_MILLISECONDS) {
        clearInterval(interval);
        return;
      }
      if (document.visibilityState === 'visible') reloadRef.current();
    }, REVIEW_REFRESH_MILLISECONDS);
    return () => clearInterval(interval);
  }, [isActive]);
  return { restart: () => { startedAtRef.current = Date.now(); } };
}
